import request from '@/utils/request'
const BASE_URL = '/RpWoDoc'

export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  getGoodsList(id) {
    return request({
      url: BASE_URL + '/getGoodsList',
      method: 'get',
      params: { id }
    })
  },
  addGoods(data) {
    return request({
      url: BASE_URL + '/addGoods',
      method: 'post',
      data
    })
  },
  updateGoods(data) {
    return request({
      url: BASE_URL + '/updateGoods',
      method: 'post',
      data
    })
  },
  deleteGoods(orderGoodsId) {
    return request({
      url: BASE_URL + '/deleteGoods',
      method: 'get',
      params: { orderGoodsId }
    })
  },
  getSaAccount(params) {
    return request({
      url: BASE_URL + '/GetSaAccount',
      method: 'get',
      params
    })
  },
  getReceiptList(id) {
    return request({
      url: BASE_URL + '/getReceiptList',
      method: 'get',
      params: { id }
    })
  },
  examine(id) {
    return request({
      url: BASE_URL + '/Examine',
      method: 'get',
      params: { id }
    })
  },
  cancelExamine(id) {
    return request({
      url: BASE_URL + '/CancelExamine',
      method: 'get',
      params: { id }
    })
  },
  needRcvList(data) {
    return request({
      url: BASE_URL + '/VRpNeedRcvList',
      method: 'post',
      data
    })
  },
  needRcvDetail(data) {
    return request({
      url: BASE_URL + '/VRpNeedRcvDetailList',
      method: 'post',
      data
    })
  },
  needPayDetail(data) {
    return request({
      url: BASE_URL + '/VRpNeedPayDetailList',
      method: 'post',
      data
    })
  },
  VRpNeedPayList(data) {
    return request({
      url: BASE_URL + '/VRpNeedPayList',
      method: 'post',
      data
    })
  },
}